import * as tslib_1 from "tslib";
import { getPersonaNodeIdFromExtendedProperty } from './getValueFromExtendedProperty';
import createSearchFolderForPersona from '../services/createSearchFolderForPersona';
import deleteFolders from '../services/deleteFolders';
import retrievePersonaSearchFolders from '../services/retrievePersonaSearchFolders';
import { trace } from 'owa-trace';
import { logUsage } from 'owa-analytics';
import { isGuid } from 'owa-favorites';
var synchronizePersonaSearchFolderEventName = 'SynchronizePersonaSearchFolder';
// The caller of this function should not need to know if the folder existed or if it was created
export default function synchronizePersonaSearchFolder(persona, parentFolderId, source, hasPersonaInformationChanged) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var existingSearchFolders;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, retrievePersonaSearchFolders([persona.favoriteNodeId], parentFolderId)];
                case 1:
                    existingSearchFolders = _a.sent();
                    return [4 /*yield*/, findOrCreateSearchFolderForFavoritePersona(persona, existingSearchFolders, parentFolderId, source, hasPersonaInformationChanged)];
                case 2: return [2 /*return*/, _a.sent()];
            }
        });
    });
}
export function findOrCreateSearchFolderForFavoritePersona(persona, existingSearchFolders, parentFolderId, source, personaInformationChanged) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var existingSearchFolder, idToLog, newFolder, updatedFolder, error_1;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    existingSearchFolder = filterSearchFolderForPerson(persona.favoriteNodeId, existingSearchFolders);
                    idToLog = isGuid(persona.favoriteNodeId) ? persona.favoriteNodeId : '';
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 8, , 9]);
                    if (!!existingSearchFolder) return [3 /*break*/, 3];
                    // Search folder does not exist
                    logUsage(synchronizePersonaSearchFolderEventName, [
                        'SearchFolderDoesNotExist',
                        source,
                        idToLog,
                    ]);
                    return [4 /*yield*/, createSearchFolderForPersona(parentFolderId, persona)];
                case 2:
                    newFolder = _a.sent();
                    return [2 /*return*/, newFolder];
                case 3:
                    if (!personaInformationChanged) return [3 /*break*/, 6];
                    // Search folder exists, but the persona information has changed
                    logUsage(synchronizePersonaSearchFolderEventName, [
                        'SearchFolderNeedsUpdate',
                        source,
                        idToLog,
                    ]);
                    return [4 /*yield*/, deleteFolders([existingSearchFolder.FolderId.Id], true)];
                case 4:
                    _a.sent();
                    return [4 /*yield*/, createSearchFolderForPersona(parentFolderId, persona)];
                case 5:
                    updatedFolder = _a.sent();
                    return [2 /*return*/, updatedFolder];
                case 6:
                    // Search folder is up to date, filters and version changed are currently ignored
                    logUsage(synchronizePersonaSearchFolderEventName, [
                        'SearchFolderExists',
                        source,
                        idToLog,
                    ]);
                    return [2 /*return*/, existingSearchFolder];
                case 7: return [3 /*break*/, 9];
                case 8:
                    error_1 = _a.sent();
                    throw new Error('Error when creating/deleting search folder for persona: ' +
                        error_1 +
                        '. Source: ' +
                        source);
                case 9: return [2 /*return*/];
            }
        });
    });
}
function filterSearchFolderForPerson(favoriteNodeId, existingSearchFolders) {
    var filteredSearchFolders = existingSearchFolders.filter(function (folder) { return getPersonaNodeIdFromExtendedProperty(folder) === favoriteNodeId; });
    if (filteredSearchFolders.length > 1) {
        trace.error(filteredSearchFolders.length + ' items were returned, one was expected');
    }
    return filteredSearchFolders.length === 1 && filteredSearchFolders[0];
}
//# sourceMappingURL=synchronizePersonaSearchFolder.js.map